/**
 * Pure utility functions extracted from AuditTrail component
 */

export const getActionIconType = (
  action: string,
): 'CREATE' | 'UPDATE' | 'DELETE' | 'PUBLISH' | 'DEFAULT' => {
  if (action.includes('CREATE')) return 'CREATE';
  if (action.includes('UPDATE') || action.includes('EDIT')) return 'UPDATE';
  if (action.includes('DELETE')) return 'DELETE';
  if (action.includes('PUBLISH')) return 'PUBLISH';
  return 'DEFAULT';
};

export const getActionColor = (
  action: string,
): 'success' | 'warning' | 'error' | 'info' => {
  if (action.includes('CREATE')) return 'success';
  if (action.includes('UPDATE') || action.includes('EDIT')) return 'warning';
  if (action.includes('DELETE')) return 'error';
  if (action.includes('PUBLISH')) return 'info';
  return 'info';
};

export const getActionType = (action: string): string => {
  if (action.includes('CREATE')) return 'CREATE';
  if (action.includes('UPDATE') || action.includes('EDIT')) return 'UPDATE';
  if (action.includes('DELETE')) return 'DELETE';
  if (action.includes('PUBLISH')) return 'PUBLISH';
  return 'OTHER';
};
